import React from 'react';
import LoggedOut from './LoggedOut';
import LoggedIn from './LoggedIn';
import { loginCheck } from "../../functions/auth"
import { useSelector } from 'react-redux';

const Login = () => {

    const check = loginCheck();
    const { user } = useSelector(state => ({ ...state }));

    return (
        <div>

            {user && check ? <LoggedIn /> : <LoggedOut />}

        </div>
    );
};

export default Login